export class UserSettings {
    site: number = 0;
    nvr: number = 0;
    layoutOption: number = 2;
    cameraType: string = "";
    pageNo: number = 0;
    pageSize: number = 4;
    isLinkedUserSwitched: boolean = false;
    serviceTicketStatus: string = "";
    serviceTicketSite: number = 0;
    protocolSite: number = 0;
    customerContactsSite: number = 0;
    playbackSite: number = 0;
    videoReviewStatus: string = "";
    videoReviewSite: number = 0;
    monthlyDashboardFilterValues: any = null;
    assetDashboardFilterValues: any = null;
}

export interface LayoutOptions {
    value: number;
    viewOptions: string;
    pageSize: number;
}

export const LiveViewLayoutOptions: LayoutOptions[] = [
    { viewOptions: '1 Camera', value: 1, pageSize: 1 },
    { viewOptions: '4 Cameras', value: 2, pageSize: 4 },
    { viewOptions: '6 Cameras', value: 3, pageSize: 6 },
    { viewOptions: '9 Cameras', value: 4, pageSize: 9 },
]

export const LiveViewCameraLayout = {
    OneCamera: LiveViewLayoutOptions[0],
    FourCamera: LiveViewLayoutOptions[1],
    SixCamera: LiveViewLayoutOptions[2],
    NineCamera: LiveViewLayoutOptions[3],
}

export interface DefaultLayoutOption {
    layoutOption: number
    userId: number
}